import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Taxi from "../components/Taxi";

const TaxiPage = () => {
  return (
    <>
      <Header />
      <Taxi />
      <Footer />
    </>
  );
};

export default TaxiPage;
